import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import toastr from "toastr";

// Login Redux States
import {
  GENERATE_GLOBAL_NORMS,
  GLOBAL_NORMS_LIST,
  GROUP_NORMS_LIST,
  GROUP_NORMS_DETAILS_LIST,
  CREATE_GROUP_NORMS,

} from "./actionTypes"
import { normsSuccess, normsError } from "./actions"

import {
  onGenerateGlobalNorms,
  onGetGroupNormsList,
  onCreateGroupNorms,
  onGetGroupNormsDetailList,
  onGetGlobalNormsList,
  } from "helpers/backend_api_helper";

// Generate global norms
function* generateGlobalNorms({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onGenerateGlobalNorms, data);
    yield put(normsSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(normsError(error?.response?.data?.message || "Server Error"));
  }
}


// global norms list
function* listGlobalNorms({ payload: { data, callback } }) {
  try {
    const response = yield call(onGetGlobalNormsList, data);
    yield put(normsSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(normsError(error?.response?.data?.message || "Server Error"));
  }
}

function* createGroupNorms({ payload: { data, callback } }) {
  try {
    const response = yield call(onCreateGroupNorms, data);
    yield put(normsSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(normsError(error?.response?.data?.message || "Server Error"));
  }
}

function* listGroupNorms({ payload: { data, callback } }) {
  try {
    const response = yield call(onGetGroupNormsDetailList, data);
    yield put(normsSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(normsError(error?.response?.data?.message || "Server Error"));
  }
}

function* listGroupNormsDetailsList({ payload: { data, callback } }) {
  try {
    const response = yield call(onGetGroupNormsList, data);
    yield put(normsSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(normsError(error?.response?.data?.message || "Server Error"));
  }
}


function* MailBatchSaga() {
  yield takeEvery(GENERATE_GLOBAL_NORMS, generateGlobalNorms);
  yield takeEvery(GLOBAL_NORMS_LIST, listGlobalNorms);
  yield takeEvery(CREATE_GROUP_NORMS, createGroupNorms);
  yield takeEvery(GROUP_NORMS_LIST, listGroupNorms);
  yield takeEvery(GROUP_NORMS_DETAILS_LIST, listGroupNormsDetailsList);

}

export default MailBatchSaga;

